import { inject, Injectable } from '@angular/core';

import { Session } from '../models/data.model';
import { FirebaseService } from './firebase.service';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  firebaseService = inject(FirebaseService);

  async getSession(sessionId: string | null, short: string | null, deviceInfo?: string): Promise<HttpsCallableResult<unknown>> {
    const getSession = httpsCallable(this.firebaseService.functions, 'getSession');

    return getSession({ id: sessionId, short, deviceInfo });
  }

  async getSettings(short: string | null, clientId?: string): Promise<HttpsCallableResult<unknown>> {
    const getCampaign = httpsCallable(this.firebaseService.functions, 'getCampaign');

    // Use multi-tenant parameters for optimal performance
    const params: { shortCode?: string | null; clientId?: string; short?: string | null } = {};

    if (short) {
      params.shortCode = short; // New parameter name for multi-tenant
      params.short = short; // Legacy support
    }

    if (clientId) {
      params.clientId = clientId; // Multi-tenant client ID for efficient lookup
    }

    return getCampaign(params);
  }

  async updateSession(session: Session): Promise<HttpsCallableResult<unknown>> {
    const updateSession = httpsCallable(this.firebaseService.functions, 'updateSession');

    return updateSession(session);
  }

  async redeemPrize(session: Session): Promise<HttpsCallableResult<unknown>> {
    const redeemPrize = httpsCallable(this.firebaseService.functions, 'redeemPrize');

    return redeemPrize(session);
  }
}